export default __webpack_public_path__ + "4e1d0bcb534c2739dd8cb5b1640c6718.png";